"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignationAutomaticEmailType = void 0;
var AssignationAutomaticEmailType;
(function (AssignationAutomaticEmailType) {
    AssignationAutomaticEmailType[AssignationAutomaticEmailType["DriverReminder"] = 0] = "DriverReminder";
    AssignationAutomaticEmailType[AssignationAutomaticEmailType["Pending"] = 1] = "Pending";
    AssignationAutomaticEmailType[AssignationAutomaticEmailType["Accepted"] = 2] = "Accepted";
    AssignationAutomaticEmailType[AssignationAutomaticEmailType["Cancelled"] = 3] = "Cancelled";
    AssignationAutomaticEmailType[AssignationAutomaticEmailType["DeclinedByDriver"] = 4] = "DeclinedByDriver";
    AssignationAutomaticEmailType[AssignationAutomaticEmailType["DeclinedAutomatically"] = 5] = "DeclinedAutomatically";
    AssignationAutomaticEmailType[AssignationAutomaticEmailType["Change"] = 6] = "Change";
})(AssignationAutomaticEmailType || (exports.AssignationAutomaticEmailType = AssignationAutomaticEmailType = {}));
//# sourceMappingURL=AssignationAutomaticEmailType.js.map